import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Only include services that are actually implemented and linked
  const implementedServices = [
    {
      id: 'generative-ai',
      title: 'Generative AI',
      link: '/services/generative-ai'
    },
    {
      id: 'machine-learning',
      title: 'Machine Learning & Deep Learning',
      link: '/services/machine-learning'
    },
    {
      id: 'nlp',
      title: 'Natural Language Processing (NLP)',
      link: '/services/nlp'
    },
    {
      id: 'chatbot',
      title: 'Chatbot Development',
      link: '/services/chatbot'
    },
    {
      id: 'saas',
      title: 'SaaS Product Development',
      link: '/services/saas'
    },
    {
      id: 'predictive-analytics',
      title: 'Predictive Analytics',
      link: '/services/predictive-analytics'
    },
    {
      id: 'custom-software',
      title: 'Custom Software & Web Development',
      link: '/services/custom-software'
    },
    {
      id: 'ui-ux',
      title: 'UI/UX Design',
      link: '/services/ui-ux'
    },
    {
      id: 'staff-augmentation',
      title: 'Staff Augmentation',
      link: '/services/staff-augmentation'
    }
  ];

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 70%, #475569 100%)',
      color: '#cbd5e1',
      position: 'relative',
      overflow: 'hidden',
      padding: '6rem 0 3rem'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(14, 165, 233, 0.06) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(56, 189, 248, 0.04) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      {/* Floating Particles */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        pointerEvents: 'none'
      }}>
        {[...Array(8)].map((_, i) => (
          <div key={i} style={{
            position: 'absolute',
            width: '6px',
            height: '6px',
            background: 'rgba(56, 189, 248, 0.4)',
            borderRadius: '50%',
            top: `${15 + i * 12}%`,
            left: `${8 + i * 15}%`,
            animation: `float ${4 + i * 0.3}s ease-in-out infinite`,
            animationDelay: `${i * 0.4}s`
          }}></div>
        ))}
      </div>

      <div className="container" style={{ position: 'relative', zIndex: 3 }}>
        <div className="row g-4">
          {/* Company Info */}
          <div className="col-lg-4">
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <img 
                src="/images/Vallen_AI_Logo.png"
                width="50"
                height="50"
                alt="Vallen AI Logo" 
                loading="lazy"
                style={{
                  height: '70px',
                  width: 'auto',
                  marginRight: '1rem',
                  transition: 'all 0.3s ease'
                }}
              />
              <span style={{
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: '700'
              }}>Vallen AI</span>
            </div>
            
            <p style={{
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: '1.7',
              marginBottom: '2rem',
              fontSize: '1rem'
            }}>
              At Vallen AI, we believe AI is not just about technology, it is about unlocking the next level of value for businesses. 'Vallen' reflects the trust and measurable impact we deliver, while 'AI' speaks to our focus on intelligent, future-ready innovation. We build generative AI, machine learning, and custom solutions that do not just solve today is problems but prepare companies for what is coming next.
            </p>
            
            <div style={{
              display: 'flex',
              gap: '1rem'
            }} className="d-none d-md-flex">
              <a href="https://www.linkedin.com/company/vallenai" target="_blank" rel="noopener noreferrer" 
                 style={{
                   width: '45px',
                   height: '45px',
                   background: 'linear-gradient(135deg, #0077b5 0%, #005885 100%)',
                   borderRadius: '12px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   color: 'white',
                   textDecoration: 'none',
                   transition: 'all 0.3s ease',
                   boxShadow: '0 4px 15px rgba(0, 119, 181, 0.2)'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.transform = 'translateY(-3px)';
                   e.target.style.boxShadow = '0 8px 25px rgba(0, 119, 181, 0.4)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.transform = 'translateY(0)';
                   e.target.style.boxShadow = '0 4px 15px rgba(0, 119, 181, 0.2)';
                 }}>
                <i className="bi bi-linkedin" style={{ fontSize: '1.2rem' }}></i>
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer"
                 style={{
                   width: '45px',
                   height: '45px',
                   background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
                   borderRadius: '12px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   color: 'white',
                   textDecoration: 'none',
                   transition: 'all 0.3s ease',
                   boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.transform = 'translateY(-3px)';
                   e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.4)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.transform = 'translateY(0)';
                   e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                 }}>
                <i className="bi bi-twitter-x" style={{ fontSize: '1.2rem' }}></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                 style={{
                   width: '45px',
                   height: '45px',
                   background: 'linear-gradient(135deg, #1877f2 0%, #166fe5 100%)',
                   borderRadius: '12px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   color: 'white',
                   textDecoration: 'none',
                   transition: 'all 0.3s ease',
                   boxShadow: '0 4px 15px rgba(24, 119, 242, 0.2)'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.transform = 'translateY(-3px)';
                   e.target.style.boxShadow = '0 8px 25px rgba(24, 119, 242, 0.4)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.transform = 'translateY(0)';
                   e.target.style.boxShadow = '0 4px 15px rgba(24, 119, 242, 0.2)';
                 }}>
                <i className="bi bi-facebook" style={{ fontSize: '1.2rem' }}></i>
              </a>
            </div>
          </div>

          {/* Services - First Column */}
          <div className="col-lg-2 col-md-6">
            <h5 style={{
              color: 'white',
              fontWeight: '700',
              marginBottom: '1.5rem',
              fontSize: '1.1rem',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
            }}>Services</h5>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {implementedServices.slice(0, 5).map((service) => (
                <li key={service.id} style={{ marginBottom: '0.75rem' }}>
                  <Link to={service.link} style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#0ea5e9';
                    e.target.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                    e.target.style.transform = 'translateX(0)';
                  }}>
                    <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services - Second Column */}
          <div className="col-lg-2 col-md-6">
            <h5 style={{
              color: 'white',
              fontWeight: '700',
              marginBottom: '1.5rem',
              fontSize: '1.1rem',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
            }}>More Services</h5>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {implementedServices.slice(5, 9).map((service) => (
                <li key={service.id} style={{ marginBottom: '0.75rem' }}>
                  <Link to={service.link} style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#0ea5e9';
                    e.target.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                    e.target.style.transform = 'translateX(0)';
                  }}>
                    <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div className="col-lg-2 col-md-6">
            <h5 style={{
              color: 'white',
              fontWeight: '700',
              marginBottom: '1.5rem',
              fontSize: '1.1rem',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
            }}>Industries</h5>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '0.75rem' }}>
                <Link to="/industries/healthcare" style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontSize: '0.95rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0ea5e9';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                  e.target.style.transform = 'translateX(0)';
                }}>
                  <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                  Healthcare
                </Link>
              </li>
              <li style={{ marginBottom: '0.75rem' }}>
                <Link to="/industries/banking" style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontSize: '0.95rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0ea5e9';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                  e.target.style.transform = 'translateX(0)';
                }}>
                  <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                  Financial Services
                </Link>
              </li>
              <li style={{ marginBottom: '0.75rem' }}>
                <Link to="/industries/retail" style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontSize: '0.95rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0ea5e9';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                  e.target.style.transform = 'translateX(0)';
                }}>
                  <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                  Retail & E-commerce
                </Link>
              </li>
              <li style={{ marginBottom: '0.75rem' }}>
                <Link to="/industries/transport" style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontSize: '0.95rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0ea5e9';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                  e.target.style.transform = 'translateX(0)';
                }}>
                  <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                  Transportation & Logistics
                </Link>
              </li>
              <li style={{ marginBottom: '0.75rem' }}>
                <Link to="/industries/cybersecurity" style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontSize: '0.95rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#0ea5e9';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                  e.target.style.transform = 'translateX(0)';
                }}>
                  <i className="bi bi-chevron-right" style={{ fontSize: '0.8rem' }}></i>
                  Cybersecurity
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-lg-2">
            <h5 style={{
              color: 'white',
              fontWeight: '700',
              marginBottom: '1.5rem',
              fontSize: '1.1rem',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
            }}>Contact</h5>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1.5rem'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)',
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 15px rgba(14, 165, 233, 0.2)',
                  flexShrink: 0
                }}>
                  <i className="bi bi-geo-alt" style={{
                    color: 'white',
                    fontSize: '1.1rem',
                    lineHeight: 1
                  }}></i>
                </div>
                <div>
                  <div style={{
                    color: 'white',
                    fontWeight: '600',
                    marginBottom: '0.25rem'
                  }}>Austin Texas</div>
                  <div style={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '0.9rem'
                  }}>United States</div>
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)',
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 15px rgba(14, 165, 233, 0.2)',
                  flexShrink: 0
                }}>
                  <i className="bi bi-envelope" style={{
                    color: 'white',
                    fontSize: '1.1rem',
                    lineHeight: 1
                  }}></i>
                </div>
                <div>
                  <a href="mailto:contact@vallenai.com" style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease',
                    fontSize: '1rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#0ea5e9';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                  }}>
                    contact@vallenai.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr style={{
          borderColor: 'rgba(14, 165, 233, 0.2)',
          margin: '3rem 0 2rem',
          borderWidth: '1px'
        }} />

        {/* Bottom Section */}
        <div className="row align-items-center">
          <div className="col-md-6">
            <p style={{
              color: 'rgba(255, 255, 255, 0.6)',
              margin: 0,
              fontSize: '0.9rem'
            }}>© 2025 Vallen AI. All rights reserved.</p>
          </div>
          
          {/* Mobile Social Icons */}
          <div className="col-12 d-md-none mt-3">
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center'
            }}>
              <a href="https://www.linkedin.com/company/vallenai" target="_blank" rel="noopener noreferrer" 
                 style={{
                   width: '45px',
                   height: '45px',
                   background: 'linear-gradient(135deg, #0077b5 0%, #005885 100%)',
                   borderRadius: '12px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   color: 'white',
                   textDecoration: 'none',
                   transition: 'all 0.3s ease',
                   boxShadow: '0 4px 15px rgba(0, 119, 181, 0.2)'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.transform = 'translateY(-3px)';
                   e.target.style.boxShadow = '0 8px 25px rgba(0, 119, 181, 0.4)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.transform = 'translateY(0)';
                   e.target.style.boxShadow = '0 4px 15px rgba(0, 119, 181, 0.2)';
                 }}>
                <i className="bi bi-linkedin" style={{ fontSize: '1.2rem' }}></i>
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer"
                 style={{
                   width: '45px',
                   height: '45px',
                   background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
                   borderRadius: '12px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   color: 'white',
                   textDecoration: 'none',
                   transition: 'all 0.3s ease',
                   boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.transform = 'translateY(-3px)';
                   e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.4)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.transform = 'translateY(0)';
                   e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                 }}>
                <i className="bi bi-twitter-x" style={{ fontSize: '1.2rem' }}></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                 style={{
                   width: '45px',
                   height: '45px',
                   background: 'linear-gradient(135deg, #1877f2 0%, #166fe5 100%)',
                   borderRadius: '12px',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   color: 'white',
                   textDecoration: 'none',
                   transition: 'all 0.3s ease',
                   boxShadow: '0 4px 15px rgba(24, 119, 242, 0.2)'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.transform = 'translateY(-3px)';
                   e.target.style.boxShadow = '0 8px 25px rgba(24, 119, 242, 0.4)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.transform = 'translateY(0)';
                   e.target.style.boxShadow = '0 4px 15px rgba(24, 119, 242, 0.2)';
                 }}>
                <i className="bi bi-facebook" style={{ fontSize: '1.2rem' }}></i>
              </a>
            </div>
          </div>
          <div className="col-md-6 text-md-end">
            <div style={{
              display: 'flex',
              gap: '2rem',
              justifyContent: 'flex-end',
              flexWrap: 'wrap'
            }}>
              <Link to="/privacy" style={{
                color: 'rgba(255, 255, 255, 0.6)',
                textDecoration: 'none',
                transition: 'color 0.3s ease',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#0ea5e9';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'rgba(255, 255, 255, 0.6)';
              }}>
                Privacy Policy
              </Link>
              <Link to="/terms" style={{
                color: 'rgba(255, 255, 255, 0.6)',
                textDecoration: 'none',
                transition: 'color 0.3s ease',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#0ea5e9';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'rgba(255, 255, 255, 0.6)';
              }}>
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
      `}</style>
    </footer>
  );
};

export default Footer; 